import React, { useState } from 'react';
import type { Participant } from '@interactive-room';

interface CollapsedParticipantsProps {
  participants: Participant[];
  connectedCount: number;
  assessmentMode?: boolean;
  onUnlock?: (participantId: string) => void;
}

export function CollapsedParticipants({
  participants,
  connectedCount,
  assessmentMode,
  onUnlock,
}: CollapsedParticipantsProps) {
  const [open, setOpen] = useState(false);
  const connected = participants.filter((p) => p.connected && p.role === 'student');

  return (
    <div className="pointer-events-auto absolute left-4 top-4 z-20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="sala-glass flex items-center gap-2 rounded-full px-3 py-2 transition hover:border-[var(--sala-accent-neon)]"
        aria-expanded={open}
      >
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[var(--sala-accent)] font-display text-sm font-bold text-[var(--sala-void)]">
          {connectedCount}
        </span>
        <span className="sala-label hidden sm:inline">conectados</span>
        <span className="text-[10px] text-[var(--sala-ink-dim)]">{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <div className="sala-glass-raised mt-2 max-h-56 w-64 overflow-y-auto p-2">
          {connected.length === 0 ? (
            <p className="px-2 py-3 text-xs text-[var(--sala-ink-muted)]">Nadie conectado aún</p>
          ) : (
            connected.map((p) => (
              <div
                key={p.participantId}
                className="flex items-center gap-2 rounded-lg px-2 py-1.5"
                style={{ background: 'var(--sala-surface-raised)' }}
              >
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[var(--sala-accent)] text-xs font-bold text-[var(--sala-void)]">
                  {p.displayName.charAt(0).toUpperCase()}
                </span>
                <span className="truncate text-sm font-medium">{p.displayName}</span>
                {p.evaluationLocked ? (
                  <button
                    type="button"
                    className="ml-auto shrink-0 rounded px-1.5 py-0.5 text-[9px] font-bold uppercase text-amber-200"
                    style={{ background: 'rgba(120,53,15,0.5)' }}
                    onClick={() => onUnlock?.(p.participantId)}
                    title="Reactivar evaluación"
                  >
                    Bloq ↻
                  </button>
                ) : (
                  <span className="ml-auto h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
                )}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
